export const contactInfo = {
  /** Nome do profissional */
  name: 'Guilherme Pedrosa',
  /** Especialidade ou tipo (ex.: Clínica Médica) */
  specialty: 'Geriatria e Clínica Médica',
  /** Observações sobre os atendimentos */
  observation: 'Atendimentos com hora marcada',
  /** Endereço completo - linha 1 */
  addressLine1: 'Rua Siqueira Campos 121, sala 404 - Copacabana',
  /** Endereço - linha 2 (cidade, estado, CEP, país) */
  addressLine2: 'Rio de Janeiro - RJ, Brasil',
  /** Telefones (aparecem como links clicáveis) */
  phones: ['(21) 99229-0894'],
  /** E-mail (link mailto) */
  email: 'contato@pedrosa.med.br',
  /** URL do WhatsApp para agendamento de consulta */
  whatsappScheduleUrl:
    'https://api.whatsapp.com/send?phone=5521992290894&text=Ol%C3%A1!%20Vim%20pelo%20site.%20Gostaria%20de%20agendar%20uma%20consulta%20com%20o%20Dr.%20Guilherme%20Pedrosa.',
} as const;
